module.exports = __webpack_public_path__ + "img/insurance-umbrella.10d8608.png";